var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#F0F5F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "#1E2022"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 20L26.59 21.41L32.17 27H20V29H32.17L26.59 34.59L28 36L36 28L28 20Z",
    fill: "#1E2022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnRight);
export default __webpack_public_path__ + "static/media/btn-right.cdaf8092bf17247d7d48d4806d51bfb1.svg";
export { ForwardRef as ReactComponent };